module.exports = __webpack_public_path__ + "static/media/Data structure.a9a5ed01.png";